(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["elara-wear-it-with"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('elara-wear-it-with')) {
  customElements.define('elara-wear-it-with', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded === 'true') return;
      var url = this.dataset.url;
      if (!url) return;
      var self = this;
      var load = function () {
        self.dataset.loaded = 'true';
        fetch(url)
          .then(function (response) { return response.text(); })
          .then(function (text) {
            var parsed = new DOMParser().parseFromString(text, 'text/html');
            var incoming = parsed.getElementById(self.id);
            if (incoming && incoming.innerHTML.trim().length) {
              self.innerHTML = incoming.innerHTML;
            }
          })
          .catch(function (error) { console.error('[elara-wear-it-with]', error); });
      };
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries, obs) {
          if (!entries[0].isIntersecting) return;
          obs.unobserve(self);
          load();
        }, { rootMargin: '0px 0px 400px 0px' });
        observer.observe(this);
      } else {
        load();
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
